import CSS from 'csstype';
import React from 'react';

import { usePanel } from '~/src/dash/components/layout/contexts';
import {
  disableSelectTextStyle,
  getFontColor,
  getFontPresetStyle,
  getFontSize,
  getFontSizeV2,
  getFontWeight,
} from '~/src/dash/components/text/common';

interface ITextProps {
  // presets
  // these will override size and weight props
  header?: boolean;
  subheader?: boolean;
  title?: boolean;
  // size
  mini?: boolean;
  extraSmall?: boolean;
  small?: boolean;
  baseSize?: boolean;
  large?: boolean;
  extraLarge?: boolean;
  sizeV2?: boolean;
  // color
  color?: string;
  muted?: boolean;
  baseColor?: boolean;
  highlighted?: boolean;
  // weight
  baseWeight?: boolean;
  bold?: boolean;
  heavy?: boolean;
  // font style
  italic?: boolean;
  // layout
  inlineBlock?: boolean;
  // misc
  disableSelect?: boolean;
  // standard
  style?: CSS.Properties;
  className?: string;
  children?: any;
  cypressID?: string;
}

export const Text = ({
  // presets
  header,
  subheader,
  title,
  // size
  mini,
  extraSmall,
  small,
  baseSize,
  large,
  extraLarge,
  sizeV2, // rem
  // color
  color,
  muted,
  baseColor,
  highlighted,
  // weight
  baseWeight,
  bold,
  heavy,
  // font style
  italic,
  // layout
  inlineBlock,
  // misc
  disableSelect,
  // standard
  style,
  className = '',
  children,
  cypressID,
}: ITextProps) => {
  const { fontColors } = usePanel();
  const defaultColor =
    color ||
    getFontColor({
      fontColors,
      muted,
      baseColor,
      highlighted,
    });
  const fontSize = getFontSize({
    mini,
    extraSmall,
    small,
    baseSize,
    large,
    extraLarge,
  });
  const lineHeight = fontSize * 1.618;
  const presetStyle = getFontPresetStyle({
    header,
    subheader,
    title,
  });
  const unselectableTextStyle = disableSelect ? disableSelectTextStyle : {};
  return (
    <p
      className={className}
      data-cy={cypressID}
      style={{
        display: inlineBlock ? 'inline-block' : 'block',
        verticalAlign: 'middle',
        margin: '0px',
        fontSize: sizeV2
          ? getFontSizeV2({
              mini,
              extraSmall,
              small,
              baseSize,
              large,
              extraLarge,
            })
          : `${fontSize}px`,
        lineHeight: `${lineHeight}px`,
        color: defaultColor,
        fontWeight: getFontWeight({
          baseWeight,
          bold,
          heavy,
        }),
        fontStyle: italic ? 'italic' : 'inherit',
        ...unselectableTextStyle,
        ...presetStyle,
        ...style,
      }}
    >
      {children}
    </p>
  );
};
